import { TextField } from '@material-ui/core';
import React, { useState } from 'react';
import UserUnit from '../../communicator/http/User';
import Loading from '../../helper/screens/Loading';
import { useForm } from "react-hook-form";
import Message from '../../elements/message';
import { translate } from '../../helper/multilingual';
import { Link, useParams } from 'react-router-dom';
import Login from '../Login';
import Logo from '../../assets/logo.png';


const PasswordReset = () => {

    const params = useParams();

    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    const userUnit = new UserUnit();

    const [errorMessageOpen, setErrorMessageOpen] = useState(false);
    const [errorMessageType, setErrorMessageType] = useState('error');
    const [errorMessageTitle, setErrorMessageTitle] = useState("");
    const [errorMessageBody, setErrorMessageBody] = useState("");
    const [errorMessageButtonText, setErrorMessageButtonText] = useState("OK");

    if (params.key === undefined || params.secret === undefined) {
        return <Login />;
    }

    const doResetPassword = (data) => {

        setLoading(true);

        let cbSuccess = (res) => {
            setLoading(false);
            setErrorMessageTitle(res.title);
            setErrorMessageBody(res.message);
            setErrorMessageButtonText("OK");
            setErrorMessageType("success");
            setErrorMessageOpen(true);

            setValue('password', '');

        }

        let cbError = (err) => {
            setLoading(false);

            setErrorMessageTitle(err.response.data.exception.title);
            setErrorMessageBody(err.response.data.exception.message);
            setErrorMessageButtonText("OK");
            setErrorMessageType("error");
            setErrorMessageOpen(true);
        }

        userUnit.resetPassword(data.password, params.key, params.secret, cbSuccess, cbError);

    }

    return (
        <>
            <div className="login_wrapper">
                <img src={Logo} />
                <div className="login_container">
                    <Link to="/">{translate('back_to_login')}</Link>
                    <h1>{translate('reset_password')}</h1>
                    <br />
                    <form onSubmit={handleSubmit(doResetPassword)}>
                        <TextField
                            {...register('password', { required: true })}
                            error={errors.email}
                            id="standard-basic"
                            label={translate('password')}
                            type="password"
                        />
                        <input type="submit" style={{ width: '100%' }} className="button" value={translate('reset_password')} />
                    </form>
                </div>

            </div>
            <Loading visible={loading} />
            <Message
                open={errorMessageOpen}
                type={errorMessageType}
                title={errorMessageTitle}
                body={errorMessageBody}
                buttonText={errorMessageButtonText}
                buttonAction={() => setErrorMessageOpen(false)}
            />
        </>
    );
}

export default PasswordReset;